import React from 'react';
import { Result, Button } from 'antd';
import { Link } from 'react-router-dom';
import './index.css'

const NotFound = () => (
  <Result
    className='bg-dark'

    status="404"
    title="404"
    subTitle="Sorry, the page you visited does not exist."
    extra={
      <Link to="/">       
        <Button type="primary" className="contact-button bg-blue">Back to AToX</Button>
      </Link>
    }
  />
);

export default NotFound;
